import { useEffect } from "react";
import liveChat from "../live-chat.png"



function drawFavicon(count, callback) {
    const img = document.createElement('img');
    img.src = liveChat;

    img.onload = () => {
        const size = 64;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(img, 0, 0, size, size);

        if (count > 0) {
            ctx.beginPath();
            ctx.arc(size - 15, 15, 15, 0, 2 * Math.PI);
            ctx.fillStyle = 'red';
            ctx.fill();

            ctx.font = 'bold 28px sans-serif';
            ctx.fillStyle = 'white';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(count > 99 ? '99+' : count, size - 15, 15);
        }
        callback(canvas.toDataURL('image/png'));
    }
}

export default function useFaviconBadge(count) {
    useEffect(() => {
        const favicon = document.getElementById('favicon');
        if (!favicon) return;
        drawFavicon(count, (url) => {
            favicon.href = url;
        })
    }, [count])
}